import React from 'react';
import Bullet from '../../components/Bullet/Bullet';
import Link from '../../components/Link/Link';

const SafecoExplainer = () => (
    <div>
        Safeco has been protecting individuals and families since 1923. We work through local
        independent agents who live and work in your community, and we’re backed by the financial
        strength of Liberty Mutual Insurance. That means we’ll be here for you when you need us
        most.
        <div className="list row">
            <Bullet icon="chevron-right">
                <Link
                    datacy="learn-more"
                    text="Learn more about Safeco"
                    linkURL="https://www.safeco.com/about"
                />
            </Bullet>
        </div>
    </div>
);

export default SafecoExplainer;



// WEBPACK FOOTER //
// ./src/containers/SafecoExplainer/SafecoExplainer.jsx